import React, { useEffect, useState, useMemo } from 'react';
import { RedocStandalone } from 'redoc';
import { parse } from 'yaml';
import { filterApiDocs } from '../utils/splitApiDocs';

const Redoc = ({ isDetailed }) => {
    const [completeDocs, setCompleteDocs] = useState(null);
    const [error, setError] = useState(null);

    // Determine the file name based on the environment, defaulting to prod
    const env = process.env.REACT_APP_ENV || 'prod';
    const specUrl = `external.${env}.endpoints.yaml`;

    useEffect(() => {
        fetch(specUrl)
            .then((response) => {
                if (!response.ok) throw new Error('Failed to load API specification');
                return response.text();
            })
            .then((yamlText) => setCompleteDocs(parse(yamlText)))
            .catch((err) => setError(err.message));
    }, [specUrl]);

    // Re-filter the docs only when the route changes
    const filteredDocumentation = useMemo(() => {
        if (!completeDocs) return null;
        return filterApiDocs(completeDocs, isDetailed);
    }, [completeDocs, isDetailed]);

    if (error) return <div style={{ padding: '20px', color: 'red' }}>Error: {error}</div>;
    if (!filteredDocumentation) return <div style={{ padding: '20px' }}>Loading documentation...</div>;

    return (
        <RedocStandalone
            spec={filteredDocumentation}
            options={{
                nativeScrollbars: false,
                hideDownloadButton: true,
                noAutoAuth: true,
                expandDefaultServerVariables: true,
                onlyRequiredInSamples: false,
                hideLoading: true,
                expandResponses: '200',
                theme: {
                    colors: {
                        primary: {
                            main: '#474e54',
                        },
                    },  
                    typography: {
                        links: {
                        color: '#0366d6',
                        hover: '#e53935',
                        visited: '#CBC3E3',
                        },
                    },
                },
            }}
        />
    );
};

export default Redoc;